<script>
import baseMixin from '@/mixins/baseMixin'
import dayjs from '@/services/date/index'
import DateFormatToken from '@/constants/date/DateFormatToken'
import { DateTimeField } from '@/models/forms/fields/dateTimeField'
import InfoLabel from '../general/info-label.vue'

export default {
  name: 'FormSubmissionDatetimeField',
  components: {
    InfoLabel,
  },
  mixins: [baseMixin],
  props: {
    field: {
      type: DateTimeField,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    compDate() {
      if (!this.value) return ''
      return dayjs(this.value).format(DateFormatToken.LLLL)
    },
  },
}
</script>

<template>
  <div>
    <InfoLabel :label="field.label">
      <span class="font-weight-medium">{{ compDate }}</span>
    </InfoLabel>
  </div>
</template>
